export default function FacebookIcon() {
    return (<svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.99968 9.5276V16.3884H2.72254V9.5276H0V6.74569H2.72254V5.73353C2.72254 1.97583 4.35481 0 7.80841 0C8.86718 0 9.13187 0.163642 9.71167 0.29698V3.04859C9.06254 2.9395 8.87978 2.87889 8.20545 2.87889C7.40507 2.87889 6.97652 3.09708 6.58579 3.52739C6.19505 3.95771 5.99968 4.70319 5.99968 5.7699V6.75175H9.71167L8.71592 9.53366H5.99968V9.5276Z" fill="#F5F5F5" />
    </svg>
    )
}